import { computed, ref, h, reactive } from 'vue';
import CriteriaWrapper from '~/components/FilteringFacets/Criteria/CriteriaWrapper';
import useDisplay from '~/composables/filteringFacets/useDisplay';

const facetsOptions = ref({});
const activeDropdown = ref(null);

export default function useFacetOptions() {
  const buildFacetsList = (filteringFacetsStore) => {
    const facets = computed(() => filteringFacetsStore.facets);
    facetsOptions.value = facets.value.map((facet) => {
      const number = computed(() => (facet.selectedValues.length > 0 ? facet.selectedValues.length : ''));
      return {
        id: facet.name,
        contents: { text: computed(() => `${facet.name}`), number: computed(() => number.value) },
        outlined: computed(() => facet.selectedValues.length > 0),
        dropdown: {
          customComponent: h(CriteriaWrapper, { name: facet.name }),
        },
      };
    });
  };

  const updateFacetsFilter = (filteringFacetsStore) => {
    const { screen } = useDisplay();
    if (screen.value.isMobile) {
      if (facetsOptions?.value?.[0].id !== 'filter') {
        // transform face dropdown to regular by renaming the keys
        facetsOptions.value.forEach((option) => {
          option.dropdownHide = option.dropdown;
          delete option.dropdown;
        });
        // add filter facet in the beginning
        const number = computed(() => filteringFacetsStore.allSelectedCriteria.facets.map((facet) => facet.selectedValues).flat().length);
        facetsOptions.value = [
          reactive({
            id: 'filter',
            contents: {
              icon: 'utility-filter',
              text: computed(() => `${number.value > 0 ? '' : 'Filters'}`),
              number: computed(() => number.value),
            },
            outlined: computed(() => number.value > 0),
          }),
        ].concat(facetsOptions.value);
      }
    } else if (facetsOptions?.value?.[0].id === 'filter') {
      // transform regular back to facet dropdown
      facetsOptions.value.forEach((option) => {
        option.dropdown = option.dropdownHide;
        delete option.dropdownHide;
      });
      facetsOptions.value = facetsOptions.value.slice(1); // remove filter facet
    }
  };

  return {
    updateFacetsFilter,
    buildFacetsList,
    activeDropdown,
    facetsOptions,
  };
}
